(function () {
  'use strict';

  var money = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'GBP';

  function formatMoney(cents) {
    // Shopify prices are in cents. Falls back to a simple GBP format.
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en-GB', {
        style: 'currency', currency: money, maximumFractionDigits: 0
      }).format(cents / 100);
    } catch (e) {
      return '£' + Math.round(cents / 100);
    }
  }

  /* ---- Element refs (all optional; guard before use) ---------------------- */
  var cartDrawer       = document.getElementById('cartDrawer');
  var drawerBackdrop   = document.getElementById('drawerBackdrop');
  var bagCount         = document.getElementById('bagCount');
  var cartItems        = document.getElementById('cartItems');
  var emptyCart        = document.getElementById('emptyCart');
  var cartSummary      = document.getElementById('cartSummary');
  var subtotalValue    = document.getElementById('subtotalValue');
  var toast            = document.getElementById('toast');
  var mobileNav        = document.getElementById('mobileNav');
  var mobileNavBackdrop= document.getElementById('mobileNavBackdrop');

  /* ---- Drawer + toast helpers -------------------------------------------- */
  function openCart() {
    if (!cartDrawer) return;
    cartDrawer.classList.add('open');
    if (drawerBackdrop) drawerBackdrop.classList.add('backdrop-visible');
    cartDrawer.setAttribute('aria-hidden', 'false');
  }
  function closeCart() {
    if (!cartDrawer) return;
    cartDrawer.classList.remove('open');
    if (drawerBackdrop) drawerBackdrop.classList.remove('backdrop-visible');
    cartDrawer.setAttribute('aria-hidden', 'true');
  }
  function showToast(msg) {
    if (!toast) return;
    var label = toast.querySelector('[data-toast-text]') || toast;
    if (msg) label.textContent = msg;
    toast.classList.add('show');
    clearTimeout(showToast._t);
    showToast._t = setTimeout(function () { toast.classList.remove('show'); }, 1800);
  }

  function openMobileNav() {
    if (!mobileNav) return;
    mobileNav.classList.add('open');
    if (mobileNavBackdrop) mobileNavBackdrop.classList.add('backdrop-visible');
    mobileNav.setAttribute('aria-hidden', 'false');
  }
  function closeMobileNav() {
    if (!mobileNav) return;
    mobileNav.classList.remove('open');
    if (mobileNavBackdrop) mobileNavBackdrop.classList.remove('backdrop-visible');
    mobileNav.setAttribute('aria-hidden', 'true');
  }

  /* ---- Shopify cart ------------------------------------------------------- */
  function renderCart(cart) {
    if (bagCount) bagCount.textContent = cart.item_count;

    if (!cartItems) return;
    cartItems.innerHTML = '';

    if (cart.item_count === 0) {
      if (emptyCart) emptyCart.classList.remove('hidden');
      if (cartSummary) cartSummary.classList.add('hidden');
      return;
    }
    if (emptyCart) emptyCart.classList.add('hidden');
    if (cartSummary) cartSummary.classList.remove('hidden');

    cart.items.forEach(function (item) {
      var row = document.createElement('div');
      row.className = 'flex items-start justify-between gap-4 border-b border-primary/10 pb-4';
      row.innerHTML =
        '<div class="flex items-start gap-4">' +
          (item.image ? '<img src="' + item.image + '" alt="" class="w-16 h-20 object-cover rounded">' : '') +
          '<div>' +
            '<p class="heading-serif italic text-lg leading-tight text-primary">' + item.product_title + '</p>' +
            '<p class="text-xs uppercase tracking-widest mt-2 font-bold">' + formatMoney(item.final_line_price) + '</p>' +
            '<p class="text-[10px] uppercase tracking-widest mt-1 text-primary/60 font-bold">Qty ' + item.quantity + '</p>' +
          '</div>' +
        '</div>' +
        '<button class="remove-item text-[10px] uppercase tracking-widest underline underline-offset-4 focus-ring font-bold" ' +
          'data-line-key="' + item.key + '">Remove</button>';
      cartItems.appendChild(row);
    });

    if (subtotalValue) subtotalValue.textContent = formatMoney(cart.items_subtotal_price);

    cartItems.querySelectorAll('.remove-item').forEach(function (btn) {
      btn.addEventListener('click', function () {
        changeLine(btn.dataset.lineKey, 0);
      });
    });
  }

  function fetchCart() {
    return fetch(window.Shopify.routes.root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { renderCart(cart); return cart; });
  }

  function addToCart(id, qty) {
    return fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: id, quantity: qty || 1 })
    })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
      .then(function (res) {
        if (!res.ok) { showToast(res.data.description || 'Sorry, that item is unavailable.'); return; }
        showToast('Added to your bag');
        return fetchCart().then(openCart);
      })
      .catch(function () { showToast('Something went wrong. Please try again.'); });
  }

  function changeLine(key, quantity) {
    return fetch(window.Shopify.routes.root + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
      .then(function (r) { return r.json(); })
      .then(renderCart);
  }

  /* ---- Wire up DOM -------------------------------------------------------- */
  document.addEventListener('DOMContentLoaded', function () {
    if (window.lucide) lucide.createIcons();

    // Ensure Shopify.routes.root exists (older themes / dev)
    window.Shopify = window.Shopify || {};
    window.Shopify.routes = window.Shopify.routes || { root: '/' };

    // Bag open/close
    var bagBtn = document.getElementById('bagBtn');
    if (bagBtn) bagBtn.addEventListener('click', function (e) { e.preventDefault(); openCart(); });
    var closeBtn = document.getElementById('closeCart');
    if (closeBtn) closeBtn.addEventListener('click', closeCart);
    var continueShopping = document.getElementById('continueShopping');
    if (continueShopping) continueShopping.addEventListener('click', closeCart);
    if (drawerBackdrop) drawerBackdrop.addEventListener('click', closeCart);

    // Mobile nav
    var menuBtn = document.getElementById('mobileMenuBtn');
    if (menuBtn) menuBtn.addEventListener('click', openMobileNav);
    var closeNav = document.getElementById('closeMobileNav');
    if (closeNav) closeNav.addEventListener('click', closeMobileNav);
    if (mobileNavBackdrop) mobileNavBackdrop.addEventListener('click', closeMobileNav);
    if (mobileNav) mobileNav.querySelectorAll('a').forEach(function (a) {
      a.addEventListener('click', closeMobileNav);
    });

    // Quick-add buttons (carry data-variant-id from the product card)
    document.querySelectorAll('[data-quick-add]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var id = btn.getAttribute('data-variant-id');
        if (id) addToCart(id, 1);
      });
    });

    // Category filter chips (filter by data-category on the cards)
    document.querySelectorAll('.filter-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var f = btn.dataset.filter;
        document.querySelectorAll('.filter-btn').forEach(function (b) { b.classList.remove('active'); });
        btn.classList.add('active');
        document.querySelectorAll('[data-category]').forEach(function (card) {
          card.style.display = (f === 'all' || card.dataset.category === f) ? '' : 'none';
        });
      });
    });

    // Checkout → hand off to Shopify
    var checkoutBtn = document.getElementById('checkoutBtn');
    if (checkoutBtn) checkoutBtn.addEventListener('click', function () {
      window.location.href = window.Shopify.routes.root + 'checkout';
    });

    // Newsletter handled by Shopify {% form 'customer' %} — no JS needed.

    // Welcome popup — show once per visitor unless dismissed/subscribed.
    var popup = document.getElementById('welcomePopup');
    if (popup) {
      var SEEN = 'eklectable_popup_seen';
      var posted = popup.querySelector('.text-accent');
      function hidePopup() {
        popup.classList.add('hidden');
        popup.classList.remove('flex');
        try { localStorage.setItem(SEEN, '1'); } catch (e) {}
      }
      var closeBtn = document.getElementById('closePopup');
      if (closeBtn) closeBtn.addEventListener('click', hidePopup);
      popup.addEventListener('click', function (e) { if (e.target === popup) hidePopup(); });
      var seen = false;
      try { seen = localStorage.getItem(SEEN) === '1'; } catch (e) {}
      if (posted) {
        // form just submitted successfully — show it, then mark seen
        popup.classList.remove('hidden'); popup.classList.add('flex');
        try { localStorage.setItem(SEEN, '1'); } catch (e) {}
      } else if (!seen) {
        setTimeout(function () { popup.classList.remove('hidden'); popup.classList.add('flex'); }, 2500);
      }
    }

    // Accordion exclusivity on product page (<details class="group">)
    var allDetails = document.querySelectorAll('details.group');
    allDetails.forEach(function (d) {
      d.addEventListener('toggle', function () {
        if (d.open) allDetails.forEach(function (o) { if (o !== d) o.removeAttribute('open'); });
      });
    });

    fetchCart();
  });

  // Expose for other inline scripts (e.g. product form)
  window.EklectableCart = { add: addToCart, open: openCart, refresh: fetchCart };
})();
